import Layout from '@/layout'

const route = {
  path: '/baiduAD/list',
  component: Layout,
  redirect: '/baiduAD/list',
  alwaysShow: true, // will always show the root menu
  name: 'baiduADList',
  meta: {
    title: '百度广告',
    icon: 'baidu',
    roles: [
      'baidu_ad'
    ]
  },
  children: [
    {
      path: '/baiduAD/primaryAccount/index',
      component: () => import('@/views/baiduAD/primaryAccount/index.vue'),
      name: 'baiduADPrimaryAccountAD',
      meta: {
        title: '主账号',
        icon: 'component',
        roles: [
          'baidu_ad.account.account_list'
        ]
      }
    },
    {
      path: '/baiduAD/accountAD/index',
      component: () => import('@/views/baiduAD/account/index.vue'),
      name: 'baiduADaccountAD',
      meta: {
        title: '账户列表',
        icon: 'component',
        roles: [
          'baidu_ad.account.sub_list'
        ]
      }
    },
    {
      path: '/baiduAD/creativeFeed/index',
      component: () => import('@/views/baiduAD/creativeFeed/index.vue'),
      name: 'baiduADcreativeFeed',
      meta: {
        title: '创意列表',
        icon: 'component',
        roles: [
          'baidu_ad.creative_feed.list'
        ]
      }
    },
    {
      path: '/baiduAD/Plan/index',
      component: () => import('@/views/baiduAD/Plan/index.vue'),
      name: 'baiduAdPlan',
      meta: {
        title: '信息流计划',
        icon: 'component',
        roles: [
          'baidu_ad.campaign_feed.list'
        ]
      }
    },
    {
      path: '/baiduAD/wisdom/index',
      component: () => import('@/views/baiduAD/wisdom/index.vue'),
      name: 'wisdom',
      meta: {
        title: '智投项目列表',
        icon: 'component',
        roles: [
          'baidu_ad.project_feed.list'
        ]
      }
    },
    {
      path: '/baiduAD/AdgroupFeed/index',
      component: () => import('@/views/baiduAD/adgroupFeed/index.vue'),
      name: 'wisdom',
      meta: {
        title: '推广单元列表',
        icon: 'component',
        roles: [
          'baidu_ad.adgroup_feed.list'
        ]
      }
    },
    {
      path: '/baiduAD/copyRecord/index',
      component: () => {
        return import('@/views/baiduAD/copyRecord/index.vue')
      },
      name: 'baiduADcopyRecord',
      meta: {
        title: '复制记录',
        // icon: 'el-icon-set-up',
        roles: [
          'baidu_ad.copy.job_list'
        ]
      }
    },
    {
      path: 'baiduAD/property/index',
      component: () => {
        return import('@/views/messageTemplate/index.vue')
      },
      name: 'baiduADCopyRecordIndex',
      meta: {
        title: '资产',
        // icon: 'el-icon-set-up',
        roles: [
          'baidu_ad.assets'
        ]
      },
      children: [
        {
          path: '/baiduAD/property/img',
          component: () => {
            return import('@/views/baiduAD/property/imageList.vue')
          },
          name: 'baiduPropertyImg',
          meta: {
            title: '素材图片',
            // icon: 'el-icon-set-up',
            roles: [
              'baidu_ad.assets.image_list'
            ]
          }
        },
        {
          path: '/baiduAD/property/video',
          component: () => {
            return import('@/views/baiduAD/property/videoList.vue')
          },
          name: 'baiduPropertyVideo',
          meta: {
            title: '素材视频',
            // icon: 'el-icon-set-up',
            roles: [
              'baidu_ad.assets.video_list'
            ]
          }
        }
      ]
    }
  ]
}

export default route
